import { forwardRef, InputHTMLAttributes } from "react";
import clsx from "clsx";

import styles from "./Input.module.css";

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  className?: string;
  isError?: boolean;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, isError = false, ...props }, ref) => {
    return (
      <input
        ref={ref}
        className={clsx(styles.input, className, isError && styles.error)}
        {...props}
      />
    );
  },
);

Input.displayName = "Input";
